<template>
  <div
    class="input-field"
    :class="{ 'error': validationError }"
  >
    <label v-if="label">
      {{ label }}

      <span
        v-if="required"
        class="text-red-600"
      >*</span>
    </label>

    <input
      v-model="model"
      :type="type"
      :placeholder="placeholder"
      :required="required"
      :pattern="pattern"
      v-bind="$attrs"
    >

    <small
      v-if="hint"
      class="text-black"
    >{{ hint }}</small>

    <span
      v-if="validationError"
      class="validation-error-message"
    >
      {{ validationError }}
    </span>
  </div>
</template>

<script setup>
defineProps({
  placeholder: {
    type: String,
    default: null,
  },
  label: {
    type: String,
    default: null,
  },
  required: {
    type: Boolean,
    default: false,
  },
  focus: {
    type: Boolean,
    default: false,
  },
  validationError: {
    type: Object,
    default: () => null,
  },
  pattern: {
    type: String,
    default: null,
  },
  type: {
    type: String,
    default: 'text',
  },
  hint: {
    type: String,
    default: '',
  },
});

const model = defineModel();
</script>
